import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { all, takeEvery, take, call, put, fork } from 'redux-saga/effects';
import { isApiError, requestPuppy } from '@wix/da-http-client';
import { uploadFile, uploadFiles, uploadFailure, uploadSuccess, uploadProgress, uploadFileImmediately, cancelFileUpload } from '../actions';
import { createUploadChannel } from './base';
import { uploadQueueWatcher } from './queue';
const PCP_FOLDER_NAME = 'PCP attachments';
const DRAFTS_FOLDER_NAME = 'Saved Submissions';
const MEDIA_FOLDER_NAME = 'Media Uploads';
const fakeDeviationFetch = (options)=>{
    if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line
        const { deviationsByType } = require('@wix/da-sample-data');
        return _object_spread({}, deviationsByType.image[0], {
            deviationId: options.params.deviationid
        });
    }
};
function* createDeviationUploadChannel({ file, deviationId, folderId, folderName, useDefaults, isPreviewUpload }) {
    const baseUrl = 'deviation/submit/upload';
    let url = deviationId ? `${baseUrl}/replace_original` : `${baseUrl}/deviation`;
    if (isPreviewUpload) {
        url = `${baseUrl}/replace_preview`;
    }
    const formData = new FormData();
    if (deviationId) {
        formData.append('deviationid', deviationId);
        if (isPreviewUpload) {
            formData.append('preview_file', file);
        } else {
            formData.append('original_file', file);
        }
    } else {
        formData.append('upload_file', file);
        formData.append('use_defaults', useDefaults);
        if (folderId) {
            formData.append('folderid', folderId);
        } else {
            formData.append('folder_name', folderName);
        }
    }
    return yield call(createUploadChannel, url, formData, 'deviation');
}
function* uploadFileHandler(action) {
    const { file, uploadId, deviationId, folderId, autoFetchDeviationOnSuccess, isPcp, isDraft, useDefaults, onSuccess, onFailure, isPreviewUpload } = action.payload;
    // Unless folderid is specified, the folder will be set by name, which will be one of these 3:
    // - "PCP attachments" if it's a pcp asset
    // - "Saved Submissions" if it's a draft upload on studio
    // - "Media Uploads" if it's anything else (e.g. editor uploads)
    // - Stash protect folder name, as defined in `useFileUpload` hook
    const folderName = action.payload.folderName || (isDraft ? DRAFTS_FOLDER_NAME : isPcp ? PCP_FOLDER_NAME : MEDIA_FOLDER_NAME);
    const channel = yield call(createDeviationUploadChannel, {
        file,
        deviationId,
        folderId,
        folderName,
        useDefaults,
        isPreviewUpload
    });
    // If a cancel action for this file id is fired we close the channel
    yield fork(function*() {
        yield take(({ type, payload })=>type === cancelFileUpload.toString() && payload.uploadId === uploadId);
        channel.close();
    });
    while(true){
        const { progress = 0, error, success, response } = yield take(channel);
        if (error) {
            yield put(uploadFailure(uploadId, error));
            if (onFailure) {
                yield call(onFailure, {
                    uploadId
                }, error);
            }
            return;
        }
        if (success) {
            const uploadedDeviationId = deviationId ? response === null || response === void 0 ? void 0 : response.deviationId : response === null || response === void 0 ? void 0 : response.privateId;
            yield put(uploadSuccess(uploadId, uploadedDeviationId));
            if (onSuccess) {
                let deviation;
                if (autoFetchDeviationOnSuccess && uploadedDeviationId) {
                    const params = {
                        deviationid: uploadedDeviationId,
                        type: 'art'
                    };
                    const result = yield call(requestPuppy, {
                        method: 'get',
                        url: '/deviation/fetch',
                        params: params
                    }, fakeDeviationFetch);
                    if (result && !isApiError(result)) {
                        deviation = result;
                    }
                }
                yield call(onSuccess, {
                    uploadId,
                    file,
                    deviationId: uploadedDeviationId,
                    deviation
                });
            }
            return;
        }
        yield put(uploadProgress(uploadId, progress));
    }
}
export default function* saga() {
    yield all([
        takeEvery(uploadFileImmediately, uploadFileHandler),
        uploadQueueWatcher('deviation', [
            uploadFile,
            uploadFiles,
            uploadSuccess,
            uploadFailure
        ], uploadFileImmediately, true // turn on sequenced uploads
        )
    ]);
}

//# sourceMappingURL=deviations.js.map